import main from '../components/seal-rtc/main.vue';

export default [
    {
        path: '/seal-rtc',
        name: 'seal-rtc',
        components: {
            onlyMain: main,
        },
    },
];
